import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { Monogram } from "@/components/Monogram";
import { clearToken } from "@/lib/api";

const scrollTo = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -220 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => (
  <motion.header
    initial={{ y: -50, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 1.6, duration: 1, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-0 z-50 flex items-center justify-between border-b border-black/5 bg-[#FAFAF7]/80 px-6 py-5 backdrop-blur-md lg:px-12"
  >
    <button
      data-testid="header-logo"
      onClick={() => scrollTo("#top")}
      className="flex items-center gap-3 text-[#131311] transition-colors hover:text-[#9A7B24]"
    >
      <Monogram size={170} className="h-12 w-12 shrink-0 sm:h-[170px] sm:w-[170px]" />
      <span className="font-display hidden text-lg font-light tracking-[0.3em] sm:block">ROY A SMITH</span>
    </button>

    <nav className="flex items-center gap-6 lg:gap-10">
      <button
        data-testid="nav-archive-link"
        onClick={() => scrollTo("#archive")}
        className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500 transition-colors hover:text-[#9A7B24]"
      >
        Projects
      </button>
      <button
        data-testid="nav-about-link"
        onClick={() => scrollTo("#about")}
        className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500 transition-colors hover:text-[#9A7B24]"
      >
        About
      </button>
      <button
        data-testid="nav-contact-link"
        onClick={() => scrollTo("#contact")}
        className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500 transition-colors hover:text-[#9A7B24]"
      >
        Contact
      </button>
      <button
        data-testid="header-lock-btn"
        title="Lock the archive"
        onClick={() => {
          clearToken();
          window.location.reload();
        }}
        className="text-zinc-400 transition-colors hover:text-[#9A7B24]"
      >
        <Lock size={15} />
      </button>
    </nav>
  </motion.header>
);
